/* a11y 1.3.1: drop aria-controls on header links whose dialog isn't on the page
   (search-drawer and cart-drawer are disabled in overlay-group; news-modal isn't placed).
   Each dialog binds its own [aria-controls="<id>"] click handler, so when the dialog is
   missing nothing intercepts the click and the href still works. */
['search-drawer', 'cart-drawer', 'news-modal'].forEach((id) => {
  if (document.getElementById(id)) return;
  document.querySelectorAll(`.header [aria-controls="${id}"]`).forEach((el) => el.removeAttribute('aria-controls'));
});

/* a11y 2.2.2: Pause/Play buttons from snippets/a11y-motion-toggle.liquid.
   Videos: the theme restarts them on its own (slideshow, tab visibility), so a paused video is re-paused on play.
   Marquee: uses the pause()/play() added to MarqueeText in theme.js.
   Visitors with reduced motion start paused. */
document.querySelectorAll('[data-a11y-motion-toggle]').forEach((button) => {
  const target = document.getElementById(button.getAttribute('aria-controls'));
  if (!target) return;
  const video = target.querySelector('video');
  let paused = false;
  const set = (value) => {
    paused = value;
    if (video) {
      paused ? video.pause() : video.play().catch(() => {});
    } else {
      paused ? target.pause() : target.play();
    }
    button.firstElementChild.classList.toggle('hidden', paused);
    button.lastElementChild.classList.toggle('hidden', !paused);
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
  };
  video?.addEventListener('play', () => { if (paused) video.pause(); });
  button.addEventListener('click', () => set(!paused));
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    customElements.whenDefined(target.localName).then(() => set(true));
  }
});

/* a11y 1.2.2: Shopify Files serves .vtt as application/octet-stream and Firefox only loads text/vtt tracks,
   so re-serve the file from a text/vtt blob. */
document.querySelectorAll('video track[src*=".vtt"]').forEach(async (track) => {
  try {
    const response = await fetch(track.src);
    if (!response.ok || (response.headers.get('content-type') || '').includes('text/vtt')) return;
    track.src = URL.createObjectURL(new Blob([await response.text()], { type: 'text/vtt' }));
  } catch (error) {}
});

/* a11y 2.2.2: carousels with a Pause button start paused when the visitor has reduced motion turned on */
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  customElements.whenDefined('carousel-player-button').then(() => {
    document.querySelectorAll('carousel-player-button').forEach((element) => {
      const player = element.carousel?.player;
      const button = element.querySelector('button');
      if (!player || !button) return;
      player.userPaused = true;
      player.pause();
      button.firstElementChild.classList.add('hidden');
      button.lastElementChild.classList.remove('hidden');
      if (button.dataset.labelPlay) button.setAttribute('aria-label', button.dataset.labelPlay);
    });
  });
}

/* a11y 4.1.2: the theme skips moving focus into dialogs on touch screens; do it for the mobile menu */
document.getElementById('menu-drawer')?.addEventListener('dialog:after-show', (event) => {
  const drawer = event.currentTarget;
  if (drawer.contains(document.activeElement)) return;
  drawer.querySelector('header-menu-drawer-panel.is-visible a[href], header-menu-drawer-panel.is-visible button')?.focus({ preventScroll: true });
});
